module.exports = __webpack_public_path__ + "static/img13-6019f47cc4bc7064f459c8bb9bf43d89.jpg";